import { render, staticRenderFns } from "./Client1099List.vue?vue&type=template&id=0858d3d0&"
import script from "./Client1099List.vue?vue&type=script&lang=ts&"
export * from "./Client1099List.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports